import CacheManager from "./classes/CacheManager.js";

export const isIpad = () => {
  // iPad on iOS 13 detection
  return navigator.userAgent.includes("Mac") && "ontouchend" in document;
};

/**
 * @returns {boolean}
 */
export const isIphone = () => navigator.userAgent.includes("iPhone");

/**
 * @returns {boolean}
 */
export function isIphoneLessThan15() {
  if (!isIphone()) return false;

  const w = window.screen.width * window.devicePixelRatio;
  const h = window.screen.height * window.devicePixelRatio;

  // iPhone 15 / 15 Pro / 16 series use these resolutions
  const iphone15AndNewer =
    // 6.1" models (393x852 logical @3x)
    (Math.abs(w - 1179) < 10 && Math.abs(h - 2556) < 10) ||
    // 6.7" models (430x932 logical @3x)
    (Math.abs(w - 1290) < 10 && Math.abs(h - 2796) < 10);

  return !iphone15AndNewer;
}
/**
 *
 * @param {number} container
 * @param {number} from
 * @param {number} till
 * @param {number} speed
 * @returns {number}
 */
export function getDragOffset(container, from, till, speed) {
  const offset = ((from - till) / (0xff / speed)) * container;
  const rounded = Math.round(offset);

  return Math.sign(rounded);
}

/**
 *
 * @param {TouchList} points
 * @returns {number}
 */
export function getTouchDistance(points) {
  const offsetX = Math.abs(points[0].clientX - points[1].clientX);
  const offsetY = Math.abs(points[0].clientY - points[1].clientY);

  const powerX = Math.pow(offsetX, 2);
  const powerY = Math.pow(offsetY, 2);

  return Math.round(Math.sqrt(powerX + powerY));
}

/**
 *
 * @param {string} name
 * @param {object} classes
 * @returns {HTMLButtonElement}
 */
export function createButton(name, classes = []) {
  const btn = document.createElement("button");
  btn.classList.add(`${name}-button`, ...classes);
  btn.innerHTML = `<span class="material-symbols-rounded ${name}"></span>`;

  return btn;
}

/**
 *
 * @param {Node|HTMLElement} node
 * @param {object} obj
 */
export function overwriteCss(node, obj) {
  node.style.cssText = "";
  Object.assign(node.style, obj);
}

export const CACHE_MANAGER = new CacheManager();
